import { Button, useTheme } from "@mui/material";

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import YearRangePicker from "../../../../../components/YearRangePicker";

const StatsControls = ({
	disableBranchSelect,
	onBranchChange,
	branchValue,
	branchOptions,
	yearRange,
	setYearRange,
	weightFrom,
	onWeightFromChange,
	weightTo,
	onWeightToChange,
	isLoading,
	onSubmit,
}) => {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label" htmlFor="branch-select">
						{t("branch")}:
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", width: "200px" }}>
					<FormControl fullWidth margin="none">
						<Select
							labelId="branch-select"
							onChange={onBranchChange}
							value={branchValue}
							size="small"
							displayEmpty
							disabled={disableBranchSelect}
						>
							{[{ value: "", label: t("all") }, ...branchOptions].map(
								(option) => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								)
							)}
						</Select>
					</FormControl>
				</Box>
			</Box>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: "10px",
					position: "relative",
					zIndex: "1000",
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label">
						{t("year")}:
					</Typography>
				</Box>
				<YearRangePicker
					minYear={new Date().getFullYear() - 2}
					maxYear={new Date().getFullYear()}
					onSelect={(startYear, endYear) => {
						setYearRange({ startYear, endYear });
					}}
					startYear={yearRange?.startYear}
					endYear={yearRange?.endYear}
					selectedColor={theme.palette.primary.main}
				/>
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label">
						{t("cargos_label")}:
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<Typography
						variant="label"
						component="label"
						htmlFor="weightFrom"
						sx={{ color: "#7F7F7F" }}
					>
						{t("from")}
					</Typography>
					<TextField
						id="weightFrom"
						size="small"
						value={weightFrom}
						variant="outlined"
						onChange={onWeightFromChange}
						sx={{ width: "80px" }}
						slotProps={{
							input: {
								endAdornment: "t",
							},

							inputLabel: { shrink: true },
						}}
					/>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<Typography
						variant="label"
						component="label"
						htmlFor="weightTo"
						sx={{ color: "#7F7F7F" }}
					>
						{t("to")}
					</Typography>
					<TextField
						id="weightTo"
						size="small"
						value={weightTo}
						variant="outlined"
						sx={{ width: "80px" }}
						onChange={onWeightToChange}
						slotProps={{
							input: {
								endAdornment: "t",
							},

							inputLabel: { shrink: true },
						}}
					/>
				</Box>
			</Box>
			<Box>
				<Button
					loading={isLoading}
					onClick={onSubmit}
					type="button"
					fullWidth
					variant="contained"
				>
					{t("change")}
				</Button>
			</Box>
		</Box>
	);
};

export default StatsControls;
